{
  "autoZoom": "Zoom automático",
  "averageApplicationRateWithVal": "Tasa de aplicación promedio: {{val}}",
  "averagePressureWithVal": "Presión media: {{val}}",
  "averageSpeedWithVal": "Velocidad media: {{val}}",
  "contrast": "Aumentar el contraste",
  "durationWithVal": "Duración: {{val}}",
  "linkTo": "Historia del riego",
  "noReelRuns": "No se registraron ejecuciones durante el rango de fechas seleccionado. Ajuste el rango de fechas o vuelva a consultar más tarde",
  "runsListTitle": "El carrete se ejecuta",
  "selectedRunTitleWithRunCount": "Ejecutar {{selectedRunIndex}} de {{runCount}}",
  "showBorders": "Mostrar contornos",
  "startDateWithVal": "Fecha de inicio: {{val}}",
  "tabGraphs": "Gráficos",
  "tabRuns": "Ejecuciones",
  "title": "Historia del riego",
  "totalApplicationWithVal": "Aplicación total: {{val}} acre-pulgadas.",
  "totalRunsWithItemCount": "Total de ejecuciones: {{itemCount}}",
  "applicationType": {
    "water": "Agua",
    "manure": "Purín",
    "other": "Otro"
  },
  "applicationTypeWithVal": "Aplicado: {{val}}"
}
